import { EmpreendimentoBloco } from "../../models/empreendimentoBloco";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * UpdateBlocoUseCase
 */

export class UpdateBlocosUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }
  async updateBlocos(listBlocos: EmpreendimentoBloco[]): Promise<void> {
    await this.repository.updateBlocos(listBlocos);

  }


}
